import { useState } from "react"
import PropTypes from "prop-types"
import { Button, FormControlLabel, Checkbox, DialogContent, DialogActions } from "@mui/material"
import "./style.scss"
import Markdown from "markdown-to-jsx"
import ExternalLinks from "components/link"

export default function ConfirmIntegrationDialog({ closeDialog, confirm, termsText }) {
  const [permission, setPermission] = useState(false)

  return <DialogContent className="integration-dialog">
    <ExternalLinks>
      <Markdown>{termsText}</Markdown>
    </ExternalLinks>

    <FormControlLabel
      className="permission-check"
      control={
        <Checkbox
          checked={permission}
          onChange={(e) => setPermission(e.target.checked)}
          name="permission"
          color="primary"
        />
      }
      label="By checking this box, I AGREE to the above statements. If you do not agree with any of the above statements, do not proceed."
    />
    <DialogActions>
      <Button onClick={closeDialog} color="primary">
        Cancel
      </Button>
      <Button
        disabled={!permission}
        onClick={confirm}
        color="primary"
        autoFocus
      >
        Enable
      </Button>
    </DialogActions>
  </DialogContent>
}

ConfirmIntegrationDialog.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  termsText: PropTypes.string.isRequired,
}
